import logger from '../common/safe-log';
import { doesScriptExistInDom } from '../common/utils';

const module = 'GoogleAdsTracker';

const GoogleAdsTracker = {
  pixelConfig: null,
  pixelId: null,
  conversionId: null,
  conversionValue: null,
  enabled: false,
  load: (pixelConfig) => {
    try {
      /* eslint-disable */
            if (!pixelConfig || !pixelConfig?.awId || !pixelConfig?.conversionId) {
                return;
            } else{
                GoogleAdsTracker.enabled = true;
            }

            GoogleAdsTracker.pixelConfig = pixelConfig;
            GoogleAdsTracker.pixelId = pixelConfig?.awId;
            GoogleAdsTracker.conversionId = pixelConfig?.conversionId;
            GoogleAdsTracker.conversionValue = pixelConfig?.conversionValue;

            if(!GoogleAdsTracker.pixelId.startsWith('AW-')){
                GoogleAdsTracker.pixelId = 'AW-' + GoogleAdsTracker.pixelId;
            }

            const baseGoogleAdsUrl = 'https://www.googletagmanager.com/gtag/js?id=';
            const googleAdsUrl = `${baseGoogleAdsUrl}${GoogleAdsTracker.pixelConfig}`;
            if (!doesScriptExistInDom(baseGoogleAdsUrl)) {
                var scriptElement = document.createElement('script');
                scriptElement.setAttribute('src', googleAdsUrl);
                document.head.appendChild(scriptElement);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function () { dataLayer.push(arguments); }
                window.gtag('js', new Date());
            }
            window.gtag('config', GoogleAdsTracker?.pixelId, {
              'allow_enhanced_conversions':true,
              'linker': {
                'accept_incoming': true
              }
            });
            if(window.ga_account_id || window.gu_ga4_id) {
              let tagId = window.ga_account_id;
              if(window.gu_ga4_id){
                tagId = window.gu_ga4_id;
              }
              window.gtag('get', tagId, 'client_id', (client_id) => {
                window.gu_qs['clientId'] = client_id;
                console.log('Google Client ID', client_id);
              });
              window.gtag('get', tagId, 'session_id', (session_id) => {
                window.gu_qs['sessionId'] = session_id;
                console.log('Google Session ID', session_id);
              });
            }
            /* eslint-enable */
    } catch (e) {
      logger.error('load failed', e, { module });
    }
  },
  trackEvent: (eventProperties) => {
    if(!GoogleAdsTracker.enabled){
      return;
    }
    try {
      if (window.gtag) {
        const eventName = eventProperties.eventName;
        if (eventName == 'Order Conversion') {
          const conversionEvent = GoogleAdsTracker.trackConversion(eventProperties);
          return conversionEvent;
        }
      }
    } catch (e) {
      logger.error('trackEvent failed', e, { module });
    }
  },
  trackConversion: (eventProperties) => {
    if(!GoogleAdsTracker.enabled){
      return;
    }
    try {
      if (window.gtag && GoogleAdsTracker.conversionId && GoogleAdsTracker.pixelId) {
        let options = {
          'send_to': `${GoogleAdsTracker.pixelId}/${GoogleAdsTracker.conversionId}`,
          'transaction_id': eventProperties.req_id,
        }
        if (GoogleAdsTracker?.conversionValue) {
          options.currency = 'USD',
          options.value = GoogleAdsTracker?.conversionValue
        }
        if(eventProperties.clientId && eventProperties.sessionId){
          console.log('Google Ads Client Session', eventProperties.clientId, eventProperties.sessionId);
          window.gtag('config', GoogleAdsTracker?.pixelId , {
            'client_id': eventProperties.clientId,
            'session_id': eventProperties.sessionId
          });
        }
        window.gtag('event', 'conversion', options);

        return options;
      }
    } catch (e) {
      logger.error('trackConversion failed', e, { module });
    }
  }
};
export default GoogleAdsTracker;
